import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './wrike-folder-meeting.types';
import * as constants from './wrike-folder-meeting.constants';

export const storeWrikeFolderMeeting = generateStoreResourceAction<types.IWrikeFolderMeeting>(
  constants.STORE_WRIKE_FOLDER_MEETING,
);
export const clearWrikeFolderMeeting = generateClearResourceAction(constants.CLEAR_WRIKE_FOLDER_MEETING);
